<template>
  <LayoutHeader></LayoutHeader>
  <br />
  <!-- Begin page content -->
  <div class="container">
    <router-view></router-view>
  </div>
  <!--/.End page content -->
  <LayoutFooter></LayoutFooter>
</template>

<script>
import LayoutHeader from "@/views/layout/layout-base-header";
import LayoutFooter from "@/views/layout/layout-base-footer";

export default {
  components: {
    LayoutHeader,
    LayoutFooter,
  },

  setup() {},
};
</script>

<style>
</style>
